export default {
    'jobDetails.uniformIncluded': function() {
        if (this.jobDetails.uniformIncluded) {
            this.jobDetails.socialClothing = false
        }
    },
    'jobDetails.socialClothing': function() {
        if (this.jobDetails.socialClothing) {
            this.jobDetails.uniformIncluded = false
        }
    },
    oneDayEvent: function() {
        if (this.oneDayEvent) {
            this.event.dates = [this.event.dates[0], this.event.dates[1]]
        }
    }
}
